import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Row, Button, Table, Container, Spinner, Col } from 'react-bootstrap';

import ListPagination from '../../../common/ListPagination';

import { fetchAppVersions, SET_APP_VERSION_PAGINATION } from '../../../store/actions/appversions/appVersionsActions'

import PageTitle from '../../../common/PageTitle';


class AppVersions extends Component {

  componentDidMount() {
    this.props.fetchAppVersions();
  }

  renderAppVersions = () => {

    let appversions = this.props.appversions.appversions;
    let appversionList = [];
    
    if (appversions) {
      appversionList = appversions.length ? (
        appversions.map((appversion, key) => {

          return (
            <tr key={key}>
              <td className="align-center">{appversion.version_update}</td>
              <td className="align-center">{appversion.publisher}</td>
              <td className="align-center">{appversion.status}</td>
              <td className="align-center">{appversion.published_date}</td>
            </tr>
          )
        })
      ) : (
        <tr>
          <td colSpan={7}><Spinner animation="border" size="sm" /></td>
        </tr>
      )
    }
    else {
      return (
        <tr>
          <td colSpan={7}><p className="text-danger">No data found.</p></td>
        </tr>
      )
    }

    return appversionList;
  }

  render() {
    const {
      currentPage,
      totalPages,
      numItems,
      min,
      max,
    } = this.props.appversions;

    const upsertAppVersion = (
      <Button
        id="add-client"
        size="md"
        onClick={() => {
          this.props.history.push('/app-versions/new')
        }}
      >
        Add App Version
      </Button>
    );

    return (
      <div>
        <Container className="waa-container">
          <PageTitle pageName="APP VERSIONS" actionButton={upsertAppVersion} />
          <Row>
            <Col>
              <div className="float-right">
                <ListPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  numItems={numItems}
                  min={min}
                  max={max}
                  dispatchType={SET_APP_VERSION_PAGINATION}
                  fetchCallback={() => {
                    this.props.fetchAppVersions();
                  }} />
              </div>
            </Col>
            <Table className="waa-table appversions">
              <thead>
                <tr>
                  <th>Application Version</th>
                  <th>Created By</th>
                  <th>Status</th>
                  <th>Published Date (MM-DD-YYYY)</th>
                </tr>
              </thead>
              <tbody>
                {this.renderAppVersions()}
              </tbody>
            </Table>
            <Col>
              <div className="float-right">
                <ListPagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  numItems={numItems}
                  min={min}
                  max={max}
                  dispatchType={SET_APP_VERSION_PAGINATION}
                  fetchCallback={() => {
                    this.props.fetchAppVersions();
                  }} />
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  appversions: state.appversions,
})

const mapDispatchToProps = (dispatch) => ({
  fetchAppVersions: (...args) => dispatch(fetchAppVersions(...args)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AppVersions))